import { Link } from "react-router-dom";

export const LOGO_SRC = "/ocean-wings-travel-emblem.png";
export const FULL_LOGO_SRC = "/ocean-wings-travel-logo-full.png";

export const LogoMark = ({ className = "h-11 w-12 sm:h-12 sm:w-14" }) => (
  <img src={LOGO_SRC} alt="Ocean Wings Travel logo" width="56" height="49" data-testid="brand-logo-img"
    className={`${className} shrink-0 object-contain group-hover:scale-105 transition-transform duration-300`} />
);

export const FullLogo = ({ className = "w-40" }) => (
  <img src={FULL_LOGO_SRC} alt="Ocean Wings Travel - Your journey, our wings" data-testid="brand-full-logo" className={`${className} h-auto object-contain`} />
);

export const Logo = ({ light = false, to = "/", compact = false }) => (
  <Link to={to} data-testid="brand-logo-link" className="flex items-center gap-2.5 group min-w-0">
    <LogoMark className={compact ? "h-10 w-11" : undefined} />
    <span className="leading-none min-w-0">
      <span className={`block font-display text-xl ${compact ? "" : "sm:text-2xl"} font-bold tracking-tight whitespace-nowrap ${light ? "text-white" : "text-navy"}`} data-testid="brand-name">
        Ocean Wings Travel
      </span>
      <span className={`block mt-0.5 text-[10px] uppercase tracking-[0.3em] font-semibold whitespace-nowrap ${light ? "text-aqua" : "text-ocean"}`}>
        Andaman &amp; Nicobar
      </span>
    </span>
  </Link>
);
